import { useState, useEffect } from 'react'
import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import Loader from 'react-loaders'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'M', 'e']}
              idx={15}
            />
          </h1>
          <div className="paragraphs">
            <p>
              Hello, World! My name is Saerom Hong and I am a New Jersey and New
              York City based junior front end web developer. I love to learn
              new things and create with them.
            </p>
            <p>
              I recently graduated from Bergen Community College with a major in
              Web Development and Management. I changed my career because I love
              to learn new things and create with them. Also, I love to
              challenge!
            </p>
            <p>
              I'm currently deepening my knowledge of back-end development as
              part of my journey to become a full-stack developer.
            </p>
          </div>
        </div>

        <div className="skill-detail">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['S', 'k', 'i', 'l', 'l', 's']}
              idx={15}
            />
          </h1>
          <div className="skill-container">
            <h2>Languages: JavaScript | Java | Python | PHP</h2>
            <hr />
            <h2>Front-End: React | jQuery | Bootstrap | HTML | CSS | SASS </h2>
            <hr />
            <h2>Databases: SQL | MariaDB </h2>
            <hr />
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
